

    /**
     * Установить поле поиска города
     */
    window.cities_select = [];
    window.setUpCitySelectField = function (){
        let elements = $('.select-city select:visible').not('.select2-init').addClass('select2-init');

        elements.each(function() {

            let select = $(this);

            let country = select.is('[data-country]') ? select.attr('data-country') : null;

            let dropdown_parent = $('body');
            if( select.closest('.modal-page-content').length )
                dropdown_parent = select.closest('.modal-page-content')

            select.select2({
                language: window.select2_ru,
                dropdownParent: dropdown_parent,
                ajax: {
                    url: '/city/search',
                    dataType: 'json',
                    cache: true,
                    data: function(params){
                        return {
                            search: params.term || '',
                            page: params.page || 1,
                            country: country,
                        };
                    },
                    processResults: function(data){

                        let items = data.results.data ?? [];
                        let results = [];

                        items.forEach(function(item, index){

                            cities_select[item.id] = item;

                            results.push({
                                'id': item.id,
                                'text': getCityName(item)
                            });

                        });

                        return {
                            results: results,
                            pagination: {
                                more: data.results.next_page_url
                            }
                        }
                    },
                    error: function (error,i,code) {

                        if( code !== 'abort' )
                            showError(error,code);

                    }
                },
                templateResult: function(data) {
                    return $.parseHTML(data.text);
                },
                templateSelection: function(data) {
                    return $.parseHTML(data.text);
                }
            });


        });

    };


    /**
     * Выбор города
     */
    eventChange('.select-city.dispatch select', function (elem){

        //запускаем событие выбора города
        eventDispatch('city_selected', cities_select[$(elem).val()]);

    });


    /**
     * Получить название города
     */
    getCityName = function( city, with_tags = true ){

        let name = langText(city.name);

        let open_tag = (with_tags) ? '<span>' : '';
        let close_tag = (with_tags) ? '</span>' : '';

        let extra = [];

        if( city.region )
            extra.push(langText(city.region.name));

        if( city.area )
            extra.push(langText(city.area.name));

        if( city.country )
            extra.push(langText(city.country.name));

        if( extra.length > 0 )
            name += ' '+ open_tag + '' + extra.join(', ') + '' + close_tag;

        return name;

    }

    /**
     * Получить название страны
     */
    getCountryName = function( country, with_tags = true ){

        return langText(country.name);

    }

    /**
     * Получить название региона
     */
    getRegionName = function( region, with_tags = true ){

        let name = langText(region.name);

        let open_tag = (with_tags) ? '<span>' : '';
        let close_tag = (with_tags) ? '</span>' : '';

        if( region.country )
            name += ' '+ open_tag +'(' + langText(region.country.name) + ')' + close_tag;

        return name;

    }

    /**
     Предотвратить ввод кириллицы
     */
    eventInput('[data-prevent-cyrillic]', function (data) {

        const sanitizedValue = $(data).val().replace(/[а-яА-Я]/g, '');
        $(data).val(sanitizedValue);
    })

    /**
     Предотвратить ввод латиницы
     */
    eventInput('[data-prevent-latin]', function (data) {

        const sanitizedValue = $(data).val().replace(/[a-zA-Z]/g, '');
        $(data).val(sanitizedValue);
    })

    /**
     Предотвратить ввод кроме латиницы, цифр и пробела
     */
    eventInput('[data-prevent-except-latin-numbers]', function (data) {

        const sanitizedValue = $(data).val().replace(/[^a-zA-Z0-9\s]/g, '');
        $(data).val(sanitizedValue);
    })


    /**
     * Календарь DatePicker
     */
    window.initDatePicker = function() {
        $('input.with-datepicker').each(function() {
            // Получаем значение из поля ввода
            let inputDate = $(this).val();
            let startDate;

            if (inputDate) {
                // Разбиваем строку на компоненты даты
                let parts = inputDate.split('-');
                // Создаем объект Date с использованием компонентов даты
                startDate = new Date(parts[0], parts[1] - 1, parts[2]);
            } else {
                startDate = new Date();
            }

            new AirDatepicker(this, {
                locale: localeRu,
                autoClose: true,
                dateFormat: 'yyyy-MM-dd',
                startDate: startDate, // Устанавливаем начальную дату из поля ввода
                selectedDates: [startDate]
            });
        });
    };
